/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSubEvaluationOutput } from './oralExamSubEvaluationOutput';
import type { OralExamSubmissionEvaluationOverallFeedback } from './oralExamSubmissionEvaluationOverallFeedback';
import type { OralExamSubmissionEvaluationPromptVersion } from './oralExamSubmissionEvaluationPromptVersion';

/**
 * Oral exam evaluation projection (sibling of `evaluation` on Submission).
 */
export interface OralExamSubmissionEvaluation {
  subEvaluations: OralExamSubEvaluationOutput[];
  overallFeedback?: OralExamSubmissionEvaluationOverallFeedback;
  promptVersion?: OralExamSubmissionEvaluationPromptVersion;
}
